/**
 * @fileoverview React time display for event feed messages.
 */

import React from 'react';

import { formatMessageDate, getDateObject, MessageDateValue } from '../../util/dateHelpers';

export interface MessageTimeProps {
  hasReadReceipt?: boolean;
  showMobileIcon?: boolean;
  date?: MessageDateValue;
}

const MessageTime: React.FC<MessageTimeProps> = ({
  hasReadReceipt = false,
  showMobileIcon = false,
  date = null,
}) => {
  const dateObject = getDateObject(date);
  const messageTimeTitle = getMessageTimeTitleFromDate(dateObject);
  const formattedMessageTime = getFormattedMessageTime(dateObject);

  return (
    <div className="bl-message_time">
      {hasReadReceipt ? <span className="bl-message_read-receipt">Read</span> : null}
      <span title={messageTimeTitle}>
        {dateObject ? (
          <time dateTime={dateObject.toISOString()}>{formattedMessageTime}</time>
        ) : null}
      </span>
      {showMobileIcon ? (
        <span>
          <i className="menu-item_icon bl-icon-phone"></i>
        </span>
      ) : null}
    </div>
  );
};

export default MessageTime;

/**
 * Formats the legacy hover title directly from a raw message timestamp input.
 * @param date A raw message timestamp as a number, date string, or nullish value.
 * @returns The hover title string, or an empty string when no valid date is available.
 */
export function getMessageTimeTitle(date?: MessageDateValue): string {
  return getMessageTimeTitleFromDate(getDateObject(date));
}

/**
 * Formats the visible time label for a parsed message timestamp.
 * @param dateObject A previously parsed message Date.
 * @returns The display time string, or an empty string when no valid date is available.
 */
function getFormattedMessageTime(dateObject: Date | null): string {
  return formatMessageDate(dateObject, 'h:mma');
}

/**
 * Formats the legacy hover title for a parsed message timestamp.
 * @param dateObject A previously parsed message Date.
 * @returns The hover title string, or an empty string when no valid date is available.
 */
function getMessageTimeTitleFromDate(dateObject: Date | null): string {
  return formatMessageDate(dateObject, 'MMMM D, h:mma');
}
